module.exports = __webpack_public_path__ + "img/操作手册_02.4f58619e.svg";